<template>
    <div class="collapsible-content-wrapper">
        <h1 class="header" @click="() => collapsed = !collapsed"><icon :icon="collapsed ? ['fal', 'caret-right'] : ['fal', 'caret-down']"/>&nbsp;<slot name="header"/></h1>
        <div v-show="!collapsed">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CollapsibleContent",
        props: {
            startCollapsed: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                collapsed: this.startCollapsed
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/global";

.collapsible-content-wrapper {
    display: block;
    break-inside: avoid;
}

.header {
    user-select: none;
    cursor: pointer;
    width: 100%;
}
</style>